import axios from "axios";
import { diffWordsWithSpace } from "diff";
import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Webcam from "react-webcam";
import config from "../config/config-secret.json";
import {
  nextExam,
  nextQuestion,
  setIsTypingStarted,
  setRemainingTime,
  setStartTime,
  setTypingTestDiff,
} from "./../actions/assessment";
import { SaveUserStateToServerHelper } from "./Helper";

export class TypingTest extends Component {
  constructor(props) {
    super(props);

    this.webcamRef = React.createRef();
  }

  state = {
    typing_answer: "",
    gross_wpm: 0,
    result: [],
  };

  referenceText = this.props.question.reference_typing_text;

  is_typing_started = () => {
    if (!this.props.is_typing_started) {
      this.props.setIsTypingStarted(true);
      this.props.setStartTime();
      if (this.props.assessment.has_security_features) {
        this.addCaptureImage(
          this.webcamRef.current.getScreenshot(),
          new Date()
        );
      }
    }
  };

  handleChange = (event) => {
    this.setState({ typing_answer: event.target.value });
    let exams = this.props.assessment.exams;
    if (this.props.view === "practice_test") {
      exams[this.props.assessment.exam_index].practice_answer =
        event.target.value;
    } else {
      exams[this.props.assessment.exam_index].typing_answer =
        event.target.value;
    }

    const input = event.target.value;
    const diff = diffWordsWithSpace(this.referenceText, input);
    this.setState({ result: diff });
    this.props.setTypingTestDiff(diff);
  };

  componentDidMount = () => {
    let typed_answer = "";
    if (this.props.view === "practice_test") {
      if (
        this.props.assessment.exams[this.props.assessment.exam_index]
          .practice_answer
      ) {
        typed_answer =
          this.props.assessment.exams[this.props.assessment.exam_index]
            .practice_answer;
      }
    } else {
      if (
        this.props.assessment.exams[this.props.assessment.exam_index]
          .typing_answer
      ) {
        typed_answer =
          this.props.assessment.exams[this.props.assessment.exam_index]
            .typing_answer;
      }
    }
    this.setState({
      typing_answer: typed_answer,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  onUserMedia = () => {};

  addCaptureImage = (imageb64, taken_at) => {
    axios
      .post(config.API_URL + `/administer_test/save_security_image/`, {
        imageb64,
        taken_at,
        tester_id: this.props.assessment.tester_id,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <>
        <div className="main container-fluid h-100">
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <div className="container">
                <TransitionGroup className="card-container">
                  <CSSTransition
                    key={this.props.question.id}
                    timeout={500}
                    classNames="fade"
                  >
                    <div className="test">
                      <div className="question typing">
                        {this.props.assessment.has_security_features && (
                          <Webcam
                            className="col-12 mb-4"
                            style={{
                              position: "absolute",
                              right: "100%",
                              display: "block",
                            }}
                            screenshotFormat="image/jpeg"
                            muted={false}
                            ref={this.webcamRef}
                            onUserMediaError={this.onUserMediaError}
                            onUserMedia={this.onUserMedia}
                          />
                        )}

                        <h4>
                          <span>
                            The timer will begin when you type your first
                            character. Enter only one space following a
                            sentence.
                          </span>
                        </h4>

                        <div className="row">
                          <div className="col-6">
                            <h6 className="mb-3">Text to be typed :</h6>

                            <div className="card q-typing mb-2 h-100">
                              <div
                                className="card-body"
                                style={{ userSelect: "none" }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: this.props.question.text,
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <h6 className="mb-3">Type Text here :</h6>

                            <div className="card q-typing mb-2 h-100">
                              <div className="card-body p-2">
                                <textarea
                                  rows="9"
                                  placeholder="Type here..."
                                  autoFocus
                                  onKeyDown={this.is_typing_started}
                                  value={this.state.typing_answer}
                                  onChange={this.handleChange}
                                  ref={(ref) => ref && ref.focus()}
                                  onFocus={(e) =>
                                    e.currentTarget.setSelectionRange(
                                      e.currentTarget.value.length,
                                      e.currentTarget.value.length
                                    )
                                  }
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  onCopy={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CSSTransition>
                </TransitionGroup>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  question:
    state.assessment.exams[state.assessment.exam_index].questions[
      state.assessment.question_index
    ],
  is_typing_started: state.assessment.is_typing_started,
});

const mapDispatchToProps = (dispatch) => ({
  nextExam: () => dispatch(nextExam()),
  setRemainingTime: () => dispatch(setRemainingTime()),
  setIsTypingStarted: (value) => dispatch(setIsTypingStarted(value)),
  setStartTime: () => dispatch(setStartTime(Date.now())),
  nextQuestion: (question_id, choice_ids) =>
    dispatch(nextQuestion(question_id, choice_ids)),
  setTypingTestDiff: (value) => dispatch(setTypingTestDiff(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TypingTest);
